import { SOCIAL_LINKS } from '../../lib/seo';

/**
 * The icon row in the topbar and the footer.
 *
 * Renders nothing while `SOCIAL_LINKS` is empty. The markup it replaced was
 * four `<a href="#">` per row, twice per page: eight nameless dead links on
 * every URL of the site, which is both a crawl signal saying "these go
 * nowhere" and a keyboard trap for anyone tabbing the header.
 */
export function SocialIconList({ className }: { className?: string }) {
  if (SOCIAL_LINKS.length === 0) return null;
  return (
    <div className={className}>
      <ul>
        {SOCIAL_LINKS.map((s) => (
          <li key={s.name}>
            <a
              href={s.url}
              aria-label={s.label}
              target="_blank"
              rel="noopener noreferrer me"
            >
              <i className={s.icon} aria-hidden="true" />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
